module.exports = __webpack_public_path__ + "static/img/MM019-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/MM019-1.png
// module id = t75q
// module chunks = 0